import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  // `dense` matches table-cell sizing (EditCell: px-2 py-1 text-[12px]); default is the
  // comfortable form control (px-3.5 py-2.5 text-[14px]). Named `inputSize` to avoid clashing
  // with the native numeric `size` attribute.
  inputSize?: "default" | "dense";
  invalid?: boolean;
}

// Themed text input — brand tokens (NOT shadcn defaults): grey-200 border, green focus ring,
// control radius. Forwards a ref and accepts a `className` override (twMerge-deduped via cn).
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, inputSize = "default", invalid = false, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        "w-full rounded-control border bg-white text-grey-800 outline-none transition-colors",
        "placeholder:text-grey-400 focus-visible:outline-none focus-visible:ring-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        inputSize === "dense" ? "px-2 py-1 text-[12px]" : "px-3.5 py-2.5 text-[14px]",
        invalid
          ? "border-red focus-visible:border-red focus-visible:ring-red-border"
          : "border-grey-200 focus-visible:border-green focus-visible:ring-green",
        className,
      )}
      {...props}
    />
  );
});
